export { Textarea, type TextareaProps } from './Textarea';
export { default } from './Textarea';